<template>
  <div class="section">
    <div class="container">
      <component :is="phoneFrame" :scrollable-content="isContentScrollable">
        <lock-screen v-if="platform === 'ios'" :background="newFrame">
          <push-preview-ios
            :message="formattedMessage"
            :app-icon="appIcon"
            :app-name="appName"
            @contentExpanded="isContentScrollable = !isContentScrollable"
          ></push-preview-ios>
        </lock-screen>
        <lock-screen-android
          v-if="platform === 'android'"
          :background="newFrame"
        >
          <push-preview-android
            :message="formattedMessage"
            :app-icon="appIcon"
            :app-name="appName"
            @contentExpanded="isContentScrollable = !isContentScrollable"
          ></push-preview-android>
        </lock-screen-android>
      </component>
    </div>
  </div>
</template>

<script>
import PushPreviewIos from '@/common/components/push/PushPreviewIos'
import PushPreviewAndroid from '@/common/components/push/PushPreviewAndroid'
import Phone from '@/common/components/phone/Phone'
import PhoneNew from '@/common/components/phone/PhoneNew'
import LockScreen from '@/common/components/phone/LockScreen'
import LockScreenAndroid from '@/common/components/phone/LockScreenAndroid'

export default {
  name: 'PushPreviewSection',
  components: {
    LockScreenAndroid,
    Phone,
    PhoneNew,
    LockScreen,
    PushPreviewIos,
    PushPreviewAndroid
  },
  props: {
    platform: String,
    appIcon: String,
    appName: String,
    title: {
      type: String,
      required: false
    },
    text: {
      type: String,
      required: false
    },
    icon: {
      type: String,
      required: false
    },
    actions: {
      type: Array,
      required: false
    },
    newFrame: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      message: {},
      isContentScrollable: false
    }
  },

  computed: {
    phoneFrame() {
      return this.newFrame ? 'PhoneNew' : 'Phone'
    },
    formattedMessage() {
      return Object.assign(
        {
          title: this.title || '',
          text: this.text || '',
          picture: this.icon || '',
          actions: this.actions || []
        },
        this.message
      )
    }
  }
}
</script>

<style scoped>
.container {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/common/components/push/PushPreviewSection.vue